import React, { FunctionComponent } from 'react';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconCustomer: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faUserTie} />;

export { BrassIconCustomer };
